import { CommanderFormProps } from '../types';
import { useDialogFormControls, UseDialogFormControlsParams } from './useDialogFormControls';

export type UseHandledDialogFormControlsParams<
    InputValues extends object,
    OutputValues extends object = InputValues,
> = UseDialogFormControlsParams<InputValues, OutputValues> & CommanderFormProps;

export const useHandledDialogFormControls = <InputValues extends object, OutputValues extends object = InputValues>({
    onSubmit,
    onSubmitting,
    onSuccess,
    onSubmitted,
    ...other
}: UseHandledDialogFormControlsParams<InputValues, OutputValues>) =>
    useDialogFormControls({
        ...other,
        onSubmit: async (formValues, extra) => {
            onSubmitting?.();
            try {
                await onSubmit(formValues, extra);
                onSuccess?.();
            } finally {
                onSubmitted?.();
            }
        },
    });
